import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-base';

@Component({
    selector: 'fi-news-feed-item-header-form-reminder',
    template: ` <mat-card-header>
        <div mat-card-avatar class="fi-nf-avatar-circled">
            <a
                [fiStateSref]="FiStateNames.Form.View"
                [fiStateSrefParams]="{ id: newsItem.ObjectId }"
                class="NewsFeedIcon"
            >
                <span class="fa fa-lg fa-clipboard-list"></span>
            </a>
        </div>
        <mat-card-title>
            <span
                class="cursor-pointer NewsFeedItemHeader BrandedColor"
                (click)="openUserProfileDialog(newsItem.CreatedByUserId)"
            >
                {{ newsItem.CreatedByUserName }}
            </span>
        </mat-card-title>
        <mat-card-subtitle
            class="NewsFeedTime clockCcmIcon"
            [textContent]="newsItem.ChangedOnDateTime"
        ></mat-card-subtitle>
    </mat-card-header>`,
    styleUrls: ['./news-feed-item-header-form-reminder.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderFormReminderComponent extends NewsFeedItemHeaderBase {}
